// Table column definitions for Soft Tag Manager tags list
import { createColumnHelper } from '@tanstack/react-table';
import { DropdownMenu } from '@yaradigitallabs/ahua-react';
import type { Tags } from '../types/tags.types';
import ExecutionStatusModal from './statusModal/ExecutionStatusModal';

// Helper for creating column definitions with type safety
const columnHelper = createColumnHelper<Tags>();

// Function to create columns with callback for menu actions
export const createColumns = (
  onMenuAction?: (action: string, data: Tags) => void
) => [
  // Example: Checkbox column for row selection (commented out)
  // columnHelper.display({ ... })
  // Production Site column
  columnHelper.accessor('site', {
    header: () => 'Production Site',
    cell: info => <div className="w-28 truncate">{info.getValue()}</div>,
    size: 40,
  }),
  //  Area column
  columnHelper.accessor('area', {
    header: () => 'Area',
    cell: info => <div className="w-28 truncate">{info.getValue()}</div>,
    size: 60,
  }),
  // Production Line column
  columnHelper.accessor('productionUnit', {
    header: () => 'Production Unit',
    cell: info => <div className="w-32 truncate">{info.getValue()}</div>,
    size: 100,
  }),
  // Soft Tag Name column
  columnHelper.accessor('name', {
    header: () => 'Soft Tag Name',
    cell: info => <div className="w-64 truncate">{info.getValue()}</div>,
    size: 120,
  }),
  // Description column
  columnHelper.accessor('description', {
    header: () => 'Description',
    cell: info => (
      <div className="w-80 truncate" title={info.getValue()}>
        {info.getValue()}
      </div>
    ),
    size: 200,
  }),
  columnHelper.accessor('timeseriesType', {
    header: () => 'Signal Name',
    cell: info => <div className="w-32 truncate">{info.getValue()}</div>,
    size: 60,
  }),
  columnHelper.accessor('unit', {
    header: () => 'Unit',
    cell: info => <div className="w-24 truncate">{info.getValue()}</div>,
    size: 40,
  }),
  // Author column
  columnHelper.accessor('createdBy', {
    header: () => 'Author',
    cell: info => (
      <div className="w-44 font-bold truncate">{info.getValue()}</div>
    ),
    size: 100,
  }),
  // Status column with color indicator
  columnHelper.accessor('executions', {
    header: () => 'Status',
    cell: info => {
      const executionData = info.getValue();
      return <ExecutionStatusModal executions={executionData || []} />;
    },
    size: 80,
  }),
  // Menu column for row actions (edit, etc.)
  columnHelper.display({
    id: 'menu',
    header: () => '',
    cell: info => {
      const rowData = info.row.original;
      return (
        <div className="w-10 flex gap-1">
          <DropdownMenu dir="ltr">
            <DropdownMenu.TriggerButton title="click to open the dropdown menu" />
            <DropdownMenu.Content>
              <DropdownMenu.Item
                icon="Edit"
                onClick={() => onMenuAction?.('edit', rowData)}
              >
                Edit
              </DropdownMenu.Item>
              <DropdownMenu.Item
                icon="Article"
                onClick={() => onMenuAction?.('backfill', rowData)}
              >
                Backfill
              </DropdownMenu.Item>
            </DropdownMenu.Content>
          </DropdownMenu>
        </div>
      );
    },
    size: 80,
  }),
];

// Default columns for backward compatibility
export const columns = createColumns();
